// Newsletter subscription list updated on Klaviyo directly instead of Shopify.
// https://developers.klaviyo.com/en/reference/create_client_subscription

export default function footerNewsletterScript() {
  (function () {
    const newsletterFormElement = document.getElementById('newsletter-contact__form');

    function onSubmitNewsletterForm(event) {
      event.preventDefault();

      const requestOptions = {
        method: 'POST',
        headers: {
          revision: '2025-01-15',
          'content-type': 'application/vnd.api+json',
        },
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              custom_source: 'footer newsletter form',
              profile: {
                data: {
                  type: 'profile',
                  attributes: {
                    email: document.getElementById('footer__newsletter-email').value,
                  },
                },
              },
            },
            relationships: {
              list: {
                data: {
                  type: 'list',
                  // klaviyo list id
                  id: window.environment === 'production' ? 'N9X2wG' : 'Y6ehK9',
                },
              },
            },
          },
        }),
      };

      fetch(
        `https://a.klaviyo.com/client/subscriptions/?company_id=${
          // klaviyo company ID
          window.environment === 'production' ? 'PfGtaR' : 'WGmrVg'
        }`,
        requestOptions
      )
        .then((response) => {
          if (response.status === 202) {
            if (document.querySelector('.form-message--error').classList.contains('--is-visible')) {
              document.querySelector('.form-message--error').classList.remove('--is-visible');
            }
            document.querySelector('.form-message--success').classList.add('--is-visible');
            document.getElementById('footer__newsletter-email').value = '';
          }
          return null;
        })
        .catch(() => {
          if (document.querySelector('.form-message--success').classList.contains('--is-visible')) {
            document.querySelector('.form-message--success').classList.remove('--is-visible');
          }
          document.querySelector('.form-message--error').classList.add('--is-visible');
          document.getElementById('footer__newsletter-email').value = '';
        });
    }

    if (newsletterFormElement) {
      newsletterFormElement.addEventListener('submit', onSubmitNewsletterForm);
    }
  })();
}
